<script>
import appConfig from '@/app.config'
import PageHeader from '@/components/page-header'
import Layout from '@/router/layouts/main'
import 'multi-range-slider-vue/MultiRangeSliderBarOnly.css'
import Multiselect from 'vue-multiselect'
import { Helper } from '@/mixin/helper'
import { required, requiredIf } from 'vuelidate/lib/validators'

import { GET_USERS, UPDATE_USER } from '@/services/api/master/user'
import { GET_EMPLOYEES, CREATE_EMPLOYEE } from '@/services/api/master/employees'
import { mapGetters } from 'vuex'
import { getToolsClient } from '@/services/tools'

const toolsAxios = getToolsClient()
/**
 * Starter component
 */
export default {
  page: {
    title: 'Data Pengguna',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    PageHeader,
    Multiselect,
  },
  mixins: [Helper],
  apollo: {
    users: {
      query: GET_USERS,
      result({ data, loading }) {
        if (!loading) {
          this.totalRows = data.users.users.length
          this.filteredItems = data.users.users
        }
      },
    },
    employees: {
      query: GET_EMPLOYEES,
    },
  },
  data() {
    return {
      testLang: this.$t('global.search'),
      selected: {
        listUser: [],
      },
      selectedModel: {
        listUser: [],
      },
      allSelected: {
        listUser: false,
      },
      indeterminate: {
        listUser: true,
      },
      users: {
        users: [],
      },
      employees: {
        employees: [],
      },
      ugroups: {
        ugroups: [],
      },
      form: {
        userType: 'karyawan',
        userId: null,
        fullname: null,
        password: '',
        isEmployee: false,
      },
      filterMonth: '',
      position: null,
      department: null,
      userGroup: null,
      userName: null,
      userGroupName: null,
      fav: null,
      isAddFavorit: false,
      addFavorit: null,
      showModal: false,
      show_model: null,
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      totalPages: 0,
      pageOptions: [10, 25, 50, 100],
      filter: null,
      filterOn: [],
      sortBy: 'name',
      sortDesc: false,
      barMinValueSpeed: 1,
      barMaxValueSpeed: 160,
      barMinValueDegree: 1,
      barMaxValueDegree: 100,
      barMinValueTemp: 1,
      barMaxValueTemp: 100,
      isEdit: false,
      showPasswordIcon: 'fa fa-eye',
      isPasswordShow: false,
      show: [
        { key: 'email', label: 'Email' },
        { key: 'fullname', label: 'Nama Karyawan' },
        { key: 'Department', label: 'Departemen' },
        { key: 'position', label: 'Posisi' },
        { key: 'groupName', label: 'Grup Pengguna' },
        { key: 'lastLogin', label: 'Waktu Masuk' },
      ],
      listUser: [
        {
          key: 'check',
          thClass: 'mc-table--30',
          sortable: false,
        },
        {
          key: 'email',
          label: 'Email',
          thClass: 'mc-table--50',
          tdClass: this.$store.getters['identity/hasAccessAll'](
            'sms-md-user:create',
            'sms-md-user:read'
          ) ? '' : 'pe-none',
          sortable: true,
        },
        {
          key: 'fullname',
          label: this.$t('master.user.fullname'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'groupName',
          label: this.$t('master.user.group'),
          thClass: 'mc-table--50',
          sortable: true,
        },
        {
          key: 'lastLogin',
          label: this.$t('master.user.lastLogin'),
          thClass: 'mc-table--50',
          sortable: true,
        },
      ],
      itemModal: {},
      filteredItems: [],
    }
  },
  validations: {
    form: {
      fullname: { required },
      password: {
        required: requiredIf(function () {
          return this.isEdit === false
        }),
      },
    },
  },
  async mounted() {
    this.ugroups.ugroups = await this.getUgroups()
  },
  computed: {
    /**
     * Total no. of records
     */
    rows() {
      return this.users.users.length
    },
    totalTrue() {
      return this.selectedModel.listUser.filter((c) => c === true)
    },
    title() {
      return 'Pengguna'
    },
    visibleFields() {
      if (this.show_model && this.show_model.length > 0) {
        var result = this.show_model.map((a) => a.key)

        return this.listUser.filter(function (item) {
          return item.key == 'check' || result.includes(item.key)
        })
      } else {
        return this.listUser
      }
    },
    canLoginUsers() {
      return this.users.users.filter(function (item) {
        return item.canLogin
      })
    },
    cannotLoginUsers() {
      var users = this.employees.employees.filter(function (item) {
        return !item.canLogin
      })

      var department = users.map(function (item) {
        return item.position ? item.position.departmentName : 'No Department'
      })
      department = [...new Set(department)]

      var res = []
      for (let i = 0; i < department.length; i++) {
        var usersDepartment = []
        users.forEach(function (item) {
          var userDepartment = item.position ? item.position.departmentName : 'No Department'
          if (department[i] == userDepartment) {
            usersDepartment.push(item)
          }
        })

        res.push({
          department: department[i],
          users: usersDepartment,
        })
      }

      return res
    },
    ...mapGetters({
      hasAccessAll: 'identity/hasAccessAll',
    }),
  },

  methods: {
    /**
     * Search the table data with search input
     */
    async getUgroups() {
      const filters = [{ field: 'companyId', operator: 'eq', value: 0 }]
      const queryString = filters.map(
        (filter) => `${filter.field}:${filter.operator}:${filter.value}`
      )
      const result = queryString.join(',')

      const payload = {
        filters: result,
      }
      const ugroups = await toolsAxios
        .get('/ugroup', {
          params: payload,
        })
        .catch((error) => {
          this.handleError(error)
        })

      if (!ugroups?.data) return

      return ugroups.data.data
    },

    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.filteredItems = filteredItems
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },

    toggleAll(checked, param) {
      this.selectedModel[param] = []
      this.selected[param] = []
      if (checked) {
        for (let i = 0; i < this.users.users.length; i++) {
          this.selected[param].push(i)
          this.selectedModel[param].push(true)
        }
      } else {
        for (let i = 0; i < this.users.users.length; i++) {
          this.selectedModel[param].push(false)
        }
        this.selected[param] = []
      }
    },
    checkTable(event, data, param) {
      if (event) {
        this.selected[param].push(data)
      } else {
        var myIndex = this.selected[param].indexOf(data)
        if (myIndex !== -1) {
          this.selected[param].splice(myIndex, 1)
        }
      }
    },
    add(param, obj) {
      this.users.users.push(obj)
    },
    toDelete(bvModalEvent) {
      bvModalEvent.preventDefault()
      let promises = []

      for (let i = 0; i < this.selected.listUser.length; i++) {
        var input = {
          userId: this.selected.listUser[i].userId,
          oldData: {
            canLogin: true,
            password: '',
          },
          newData: {
            canLogin: false,
            password: '',
          },
        }

        promises.push(
          this.$apollo.mutate({
            mutation: UPDATE_USER,
            variables: {
              input: input,
            },
          })
        )
      }

      Promise.all(promises).then(() => {
        this.$apollo.queries.users.refetch()
        this.$toast.success(`Data berhasil terhapus`)
        this.$bvModal.hide('modal-delete-user')
      })
    },

    resetModal() {
      this.form = {
        userType: 'karyawan',
        userId: null,
        userGroupName: null,
        password: null,
      }
    },
    handleOk(bvModalEvent) {
      if (this.isEdit) {
        // Prevent modal from closing
        bvModalEvent.preventDefault()

        this.$v.$touch()
        if (this.$v.form.$error) {
          return
        }

        if (this.form.email == '' || this.form.email == null) {
          return this.$toast.error(`Email tidak boleh kosong.`)
        }

        var passwordChange = {}
        if (this.form.password != '' && this.form.password != null) {
          passwordChange = { password: this.form.password }
        }

        var newGroups = this.form.groups.map((field) => field.ugroupId ? field.ugroupId : field.id)
        var oldGroups = this.form.groupsOld ? this.form.groupsOld.map((field) => field.id ? field.id : field.ugroupId) : []

        var input = {
          userId: this.form.userId,
          oldData: {
            groups: oldGroups,
            canLogin: false,
            ...passwordChange,
          },
          newData: {
            groups: newGroups,
            canLogin: true,
            ...passwordChange,
          },
        }

        this.$apollo
          .mutate({
            mutation: UPDATE_USER,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response.data.updateUser.isSuccessful) {
              this.$apollo.queries.users.refetch()
              this.$toast.success(`Data berhasil tersimpan`)
              this.$bvModal.hide('modal-form-user')
            } else {
              return this.$toast.error(`Terdapat kesalahan pada sistem.`)
            }
          })
      } else {
        // Prevent modal from closing
        bvModalEvent.preventDefault()

        this.$v.$touch()
        if (this.$v.form.$error) {
          return
        }

        if (this.form.email == '' || this.form.email == null) {
          return this.$toast.error(`Email tidak boleh kosong.`)
        }

        if (this.form.password != '' && this.form.password != null) {
          passwordChange = { password: this.form.password }
        }
        input = {
          fullname: this.form.fullname,
          gender: 'M',
          email: this.form.email,
          isEmployee: this.form.isEmployee,
          isAdmin: true,
          isSuperuser: true,
          isActive: true,
          canLogin: true,
          language: 'ID',
          ...passwordChange,
        }

        this.$apollo
          .mutate({
            mutation: CREATE_EMPLOYEE,
            variables: {
              input: input,
            },
          })
          .then((response) => {
            if (response.data.createEmployee.isSuccessful) {
              this.$apollo.queries.users.refetch()
              this.$toast.success(`Data berhasil tersimpan`)
              this.$bvModal.hide('modal-form-user')
            } else {
              return this.$toast.error(`Terdapat kesalahan pada sistem.`)
            }
          })
      }
    },
    handleSubmit() {
      this.$nextTick(() => {
        this.$bvModal.hide('modal-form-user')
      })
    },
    onRowClicked(item) {
      this.form = item
      this.form.password = ''
      this.form.groupsOld = item.groups
      this.isEdit = true
      this.$bvModal.show('modal-form-user')
    },
    addUser() {
      this.isEdit = false
      this.form = {
        userType: 'karyawan',
        userId: null,
        fullname: null,
        password: null,
        isEmployee: false,
        email: null,
        groupsOld: [],
      }
    },
    changeGroup(item) {
      this.form.groups = [item]
    },
    showPassword() {
      if (this.isPasswordShow) {
        this.showPasswordIcon = 'fa fa-eye'
        this.isPasswordShow = false
      } else {
        this.showPasswordIcon = 'fa fa-eye-slash'
        this.isPasswordShow = true
      }
    },
    clearCheck() {
      this.selected = {
        listUser: [],
      }

      this.selectedModel = {
        listUser: [],
      }
    },
  },
}
</script>

<template>
  <Layout>
    <div class="mc-list-header">
      <PageHeader :title="title" />

      <p class="mb-4">Daftar seluruh pengguna dalam sistem</p>

      <div class="clearfix mc-btn-group__list mc-btn-group__list--detail">
        <div class="float-end">
          <b-button
            variant="outline-primary"
            @click="$router.push({ name: 'Master Home Page' })"
            class="ms-3"
          >
            <i class="mc-fa icon-outline_arrow-left"></i>
            {{ $t('global.back') }}
          </b-button>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-12">
          <div class="mc-table-filter text-end">
            <a
              v-if="this.getAccessFunc('masterUser') || hasAccessAll(['sms-md-user:create', 'sms-md-user:read'])"
              v-b-modal.modal-form-user
              class="popup-form btn btn-primary"
              href="javascript: void(0);"
              @click="addUser"
            >
              <i class="mc-fa icon-outline_plus"></i>
              {{ $t('global.addField') }}
            </a>
          </div>
        </div>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-4 col-md-4 mc-row-check-wrapper">
            <h6 v-if="totalTrue.length" class="mc-row-check">
              <span class="badge btn-success">{{ totalTrue.length }}</span>
              Baris terpilih.
              <a class="color-primary" @click="clearCheck">Bersihkan semua</a>
            </h6>
          </div>

          <!-- Search -->
          <div class="ol-sm-8 col-md-8 d-flex flex-row-reverse mc-table-view-wrapper">
            <div class="mc-table-view">
              <p class="mc-label">Tampilkan</p>
              <multiselect
                v-model="show_model"
                :options="show"
                :multiple="true"
                placeholder="Semua Kolom"
                track-by="label"
                label="label"
              >
                <template slot="singleLabel" slot-scope="{ option }">{{ option.name }}</template>
              </multiselect>
              <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                <label class="d-inline-flex align-items-center mc-table-view__search">
                  <i class="mc-fa fas fa-search"></i>
                  <b-form-input
                    v-model="filter"
                    type="search"
                    :placeholder="$t('global.search') + '...'"
                    class="ms-2"
                  >
                  </b-form-input>
                </label>
              </div>
            </div>
          </div>
          <!-- End search -->
        </div>

        <!-- Table -->
        <div class="table-responsive my-3 border border-1">
          <b-table
            small
            show-empty
            :fields="visibleFields"
            :items="canLoginUsers"
            sort-by="fullname"
            class="datatables"
            responsive="lg"
            empty-table
            :empty-filtered-text="$t('global.emptyFilteredTable')"
            :empty-text="$t('global.emptyTable')"
            :per-page="perPage"
            :current-page="currentPage"
            :filter="filter"
            :filter-included-fields="filterOn"
            @filtered="onFiltered"
            :busy="$apollo.queries.users.loading"
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle"></b-spinner>
              </div>
            </template>

            <template #head(check)>
              <div class="form-check">
                <b-form-checkbox
                  @change="toggleAll($event, 'listUser')"
                  v-model="allSelected.listUser"
                  :indeterminate="indeterminate.listUser"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(check)="data">
              <div class="form-check">
                <b-form-checkbox
                  @change="checkTable($event, data.item, 'listUser')"
                  v-model="selectedModel.listUser[data.index]"
                  :value="true"
                  :unchecked-value="false"
                ></b-form-checkbox>
              </div>
            </template>

            <template #cell(email)="data">
              <strong class="text-primary" @click="onRowClicked(data.item)">
                {{ data.item.email }}
              </strong>
            </template>

            <template #cell(groupName)="data">
              {{ data.item.groups.map((entry) => entry.name).join(', ') }}
            </template>

            <template #cell(lastLogin)="data">
              <p class="my-0">
                {{ data.item.lastLogin ? momentDateShortMonth(data.item.lastLogin) : '-' }}
              </p>
              <p class="text-muted my-0">
                {{ data.item.lastLogin ? momentTime(data.item.lastLogin) : '' }}
              </p>
            </template>
          </b-table>
        </div>

        <div class="row">
          <div class="col-sm-12 col-md-6">
            <div id="tickets-table_length" class="dataTables_length">
              <label class="d-inline-flex align-items-center">
                <span>Menampilkan</span>
                <span>
                <b-form-select
                  class="form-select form-select-sm"
                  v-model="perPage"
                  size="sm"
                  :options="pageOptions"
                />
                </span>
                <span>entri.&nbsp;&nbsp;</span> 
                <span>Menampilkan&nbsp;
                  <strong>
                    {{filteredItems.length > 0 ? (currentPage - 1) * perPage + 1 : 0}}
                  </strong>
                  &nbsp;sampai&nbsp;
                  <strong>
                    {{Math.min(filteredItems.length, currentPage * perPage)}}
                  </strong>
                  &nbsp;dari&nbsp;
                  <strong>{{ filteredItems.length }}</strong>
                  &nbsp;entri.
                </span>
              </label>
            </div>
          </div>
          <div class="col-sm-12 col-md-6">
            <div class="dataTables_paginate paging_simple_numbers float-end">
              <ul class="pagination pagination-rounded mb-0">
                <!-- pagination -->
                <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage">
                </b-pagination>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal form for Add & Edit User -->
    <b-modal
      class="mc-modal"
      id="modal-form-user"
      :title="isEdit ? 'Ubah Pengguna' : 'Pengguna Baru'"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
      @ok="handleOk"
    >
      <div class="card-body mc-modal__filter p-2">
        <form @submit.stop.prevent="handleSubmit">
          <div class="mb-2">
            <label class="mt-3 required">Nama</label>
            <b-form-input placeholder="Nama" v-model="form.fullname"></b-form-input>

            <div v-if="$v.form.fullname.$error" class="invalid-feedback">
              <span v-if="!$v.form.fullname.required"> Nama Wajib Terisi </span>
            </div>
          </div>
          <div class="mb-2">
            <label class="required">Email</label>
            <b-form-input placeholder="Email" v-model="form.email"></b-form-input>
          </div>
          <div class="mb-2">
            <label class="required">Kata Sandi</label>

            <!-- For password not using bootstrap form group for show / hide password -->
            <div
              class="input-group auth-pass-inputgroup"
              :class="{
                'is-invalid': $v.form.password.$error,
              }"
            >
              <input
                :type="isPasswordShow ? 'text' : 'password'"
                v-model="form.password"
                class="form-control"
                placeholder="Password"
                aria-label="Password"
                aria-describedby="password-addon"
                maxlength="10"
              />
              <button
                class="btn btn-light btn-eye"
                type="button"
                id="password-addon"
                @click="showPassword"
              >
                <i :class="showPasswordIcon"></i>
              </button>
            </div>
            <div v-if="$v.form.password.$error" class="invalid-feedback">
              <span v-if="!$v.form.password.required"> Password Wajib Terisi </span>
            </div>
          </div>

          <div class="mb-2" v-if="isEdit">
            <label>Grup Pengguna</label>
            <multiselect
              v-model="form.groups"
              :options="ugroups.ugroups"
              placeholder="Pilih Grup Pengguna"
              label="name"
              @input="changeGroup"
            >
            </multiselect>
          </div>
        </form>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer">
          <b-col sm="12" md="7" class="mc-modal__filter-footer-fav"> </b-col>

          <b-col sm="12" md="5" class="">
            <b-button variant="outline-primary" @click="cancel()" class="me-3"> Batal </b-button>
            <b-button @click="handleOk" variant="primary"> Simpan </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>

    <!-- Modal for Delete Confirmation -->
    <b-modal
      class="mc-modal"
      id="modal-delete-user"
      title="Hapus"
      size="md"
      centered
      scrollable
      @hidden="resetModal"
      @ok="handleOk"
    >
      <div class="card-body mc-modal__filter p-2">
        <p>Apakah Anda yakin menghapus data berikut?</p>
        <b-list-group>
          <b-list-group-item v-for="user in selected.listUser" :key="user.userId"
            >{{ user.email }}
          </b-list-group-item>
        </b-list-group>
      </div>
      <template #modal-footer="{ cancel }">
        <b-row class="mc-modal__filter-footer mx-0">
          <b-col sm="12" md="12" class="mc-modal__filter-footer-btn">
            <b-button variant="outline-primary" @click="cancel()" class="me-2"> Tidak </b-button>
            <b-button @click="toDelete" variant="primary"> Ya </b-button>
          </b-col>
        </b-row>
      </template>
    </b-modal>
  </Layout>
</template>
